/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 7.34.1
 * source: tokenizer/tokenizer.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */
import * as dependency_1 from "./../google/api/annotations";
import * as pb_1 from "google-protobuf";
import * as grpc_1 from "@grpc/grpc-js";
import * as grpc_web_1 from "grpc-web";
export namespace tokenizer.v1 {
    export enum TokenStatus {
        TOKEN_STATUS_UNSPECIFIED = 0,
        TOKEN_STATUS_PENDING = 1,
        TOKEN_STATUS_ACTIVE = 2,
        TOKEN_STATUS_INACTIVE = 3,
        TOKEN_STATUS_SUSPENDED = 4,
        TOKEN_STATUS_FAILED = 5,
        TOKEN_STATUS_DELETE = 6
    }
    export enum Brand {
        BRAND_UNSPECIFIED = 0,
        BRAND_VISA = 1,
        BRAND_MASTERCARD = 2,
        BRAND_ELO = 3,
        BRAND_AMEX = 4,
        BRAND_HIPERCARD = 5,
        BRAND_DINERS = 6,
        BRAND_DISCOVER = 7,
        BRAND_AURA = 8,
        BRAND_JCB = 9,
        BRAND_CABAL = 10,
        BRAND_SOROCRED = 11,
        BRAND_HIPER = 12,
        BRAND_OTHER = 99
    }
    export enum Kind {
        KIND_UNSPECIFIED = 0,
        KIND_CREDIT = 1,
        KIND_DEBIT = 2
    }
    export class WebhookRedeCardTokensRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            merchantId?: string;
            events?: string[];
            data?: WebhookRedeCardTokensData;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [3], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("merchantId" in data && data.merchantId != undefined) {
                    this.merchantId = data.merchantId;
                }
                if ("events" in data && data.events != undefined) {
                    this.events = data.events;
                }
                if ("data" in data && data.data != undefined) {
                    this.data = data.data;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get merchantId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set merchantId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get events() {
            return pb_1.Message.getFieldWithDefault(this, 3, []) as string[];
        }
        set events(value: string[]) {
            pb_1.Message.setField(this, 3, value);
        }
        get data() {
            return pb_1.Message.getWrapperField(this, WebhookRedeCardTokensData, 4) as WebhookRedeCardTokensData;
        }
        set data(value: WebhookRedeCardTokensData) {
            pb_1.Message.setWrapperField(this, 4, value);
        }
        get hasData() {
            return pb_1.Message.getField(this, 4) != null;
        }
        static fromObject(data: {
            id?: string;
            merchantId?: string;
            events?: string[];
            data?: ReturnType<typeof WebhookRedeCardTokensData.prototype.toObject>;
        }): WebhookRedeCardTokensRequest {
            const message = new WebhookRedeCardTokensRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.merchantId != null) {
                message.merchantId = data.merchantId;
            }
            if (data.events != null) {
                message.events = data.events;
            }
            if (data.data != null) {
                message.data = WebhookRedeCardTokensData.fromObject(data.data);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                merchantId?: string;
                events?: string[];
                data?: ReturnType<typeof WebhookRedeCardTokensData.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.merchantId != null) {
                data.merchantId = this.merchantId;
            }
            if (this.events != null) {
                data.events = this.events;
            }
            if (this.data != null) {
                data.data = this.data.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.merchantId.length)
                writer.writeString(2, this.merchantId);
            if (this.events.length)
                writer.writeRepeatedString(3, this.events);
            if (this.hasData)
                writer.writeMessage(4, this.data, () => this.data.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookRedeCardTokensRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookRedeCardTokensRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.merchantId = reader.readString();
                        break;
                    case 3:
                        pb_1.Message.addToRepeatedField(message, 3, reader.readString());
                        break;
                    case 4:
                        reader.readMessage(message.data, () => message.data = WebhookRedeCardTokensData.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookRedeCardTokensRequest {
            return WebhookRedeCardTokensRequest.deserialize(bytes);
        }
    }
    export class WebhookRedeCardTokensData extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            tokenizationId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("tokenizationId" in data && data.tokenizationId != undefined) {
                    this.tokenizationId = data.tokenizationId;
                }
            }
        }
        get tokenizationId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set tokenizationId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            tokenizationId?: string;
        }): WebhookRedeCardTokensData {
            const message = new WebhookRedeCardTokensData({});
            if (data.tokenizationId != null) {
                message.tokenizationId = data.tokenizationId;
            }
            return message;
        }
        toObject() {
            const data: {
                tokenizationId?: string;
            } = {};
            if (this.tokenizationId != null) {
                data.tokenizationId = this.tokenizationId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.tokenizationId.length)
                writer.writeString(1, this.tokenizationId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookRedeCardTokensData {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookRedeCardTokensData();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.tokenizationId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookRedeCardTokensData {
            return WebhookRedeCardTokensData.deserialize(bytes);
        }
    }
    export class WebhookRedeCardTokensResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): WebhookRedeCardTokensResponse {
            const message = new WebhookRedeCardTokensResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): WebhookRedeCardTokensResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new WebhookRedeCardTokensResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): WebhookRedeCardTokensResponse {
            return WebhookRedeCardTokensResponse.deserialize(bytes);
        }
    }
    export class GetInstallmentsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            amount?: number;
            brand?: Brand;
            kind?: Kind;
            productId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("brand" in data && data.brand != undefined) {
                    this.brand = data.brand;
                }
                if ("kind" in data && data.kind != undefined) {
                    this.kind = data.kind;
                }
                if ("productId" in data && data.productId != undefined) {
                    this.productId = data.productId;
                }
            }
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get brand() {
            return pb_1.Message.getFieldWithDefault(this, 2, Brand.BRAND_UNSPECIFIED) as Brand;
        }
        set brand(value: Brand) {
            pb_1.Message.setField(this, 2, value);
        }
        get kind() {
            return pb_1.Message.getFieldWithDefault(this, 3, Kind.KIND_UNSPECIFIED) as Kind;
        }
        set kind(value: Kind) {
            pb_1.Message.setField(this, 3, value);
        }
        get productId() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set productId(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        static fromObject(data: {
            amount?: number;
            brand?: Brand;
            kind?: Kind;
            productId?: string;
        }): GetInstallmentsRequest {
            const message = new GetInstallmentsRequest({});
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.brand != null) {
                message.brand = data.brand;
            }
            if (data.kind != null) {
                message.kind = data.kind;
            }
            if (data.productId != null) {
                message.productId = data.productId;
            }
            return message;
        }
        toObject() {
            const data: {
                amount?: number;
                brand?: Brand;
                kind?: Kind;
                productId?: string;
            } = {};
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.brand != null) {
                data.brand = this.brand;
            }
            if (this.kind != null) {
                data.kind = this.kind;
            }
            if (this.productId != null) {
                data.productId = this.productId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.amount != 0)
                writer.writeInt64(1, this.amount);
            if (this.brand != Brand.BRAND_UNSPECIFIED)
                writer.writeEnum(2, this.brand);
            if (this.kind != Kind.KIND_UNSPECIFIED)
                writer.writeEnum(3, this.kind);
            if (this.productId.length)
                writer.writeString(4, this.productId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetInstallmentsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetInstallmentsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.amount = reader.readInt64();
                        break;
                    case 2:
                        message.brand = reader.readEnum();
                        break;
                    case 3:
                        message.kind = reader.readEnum();
                        break;
                    case 4:
                        message.productId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetInstallmentsRequest {
            return GetInstallmentsRequest.deserialize(bytes);
        }
    }
    export class GetInstallmentsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            installment?: Installment[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("installment" in data && data.installment != undefined) {
                    this.installment = data.installment;
                }
            }
        }
        get installment() {
            return pb_1.Message.getRepeatedWrapperField(this, Installment, 1) as Installment[];
        }
        set installment(value: Installment[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            installment?: ReturnType<typeof Installment.prototype.toObject>[];
        }): GetInstallmentsResponse {
            const message = new GetInstallmentsResponse({});
            if (data.installment != null) {
                message.installment = data.installment.map(item => Installment.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                installment?: ReturnType<typeof Installment.prototype.toObject>[];
            } = {};
            if (this.installment != null) {
                data.installment = this.installment.map((item: Installment) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.installment.length)
                writer.writeRepeatedMessage(1, this.installment, (item: Installment) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetInstallmentsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetInstallmentsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.installment, () => pb_1.Message.addToRepeatedWrapperField(message, 1, Installment.deserialize(reader), Installment));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetInstallmentsResponse {
            return GetInstallmentsResponse.deserialize(bytes);
        }
    }
    export class Installment extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            amount?: number;
            number?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("amount" in data && data.amount != undefined) {
                    this.amount = data.amount;
                }
                if ("number" in data && data.number != undefined) {
                    this.number = data.number;
                }
            }
        }
        get amount() {
            return pb_1.Message.getFieldWithDefault(this, 1, 0) as number;
        }
        set amount(value: number) {
            pb_1.Message.setField(this, 1, value);
        }
        get number() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set number(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            amount?: number;
            number?: number;
        }): Installment {
            const message = new Installment({});
            if (data.amount != null) {
                message.amount = data.amount;
            }
            if (data.number != null) {
                message.number = data.number;
            }
            return message;
        }
        toObject() {
            const data: {
                amount?: number;
                number?: number;
            } = {};
            if (this.amount != null) {
                data.amount = this.amount;
            }
            if (this.number != null) {
                data.number = this.number;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.amount != 0)
                writer.writeInt64(1, this.amount);
            if (this.number != 0)
                writer.writeInt32(2, this.number);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): Installment {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new Installment();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.amount = reader.readInt64();
                        break;
                    case 2:
                        message.number = reader.readInt32();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): Installment {
            return Installment.deserialize(bytes);
        }
    }
    export class GetSupportedBrandsRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): GetSupportedBrandsRequest {
            const message = new GetSupportedBrandsRequest({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSupportedBrandsRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSupportedBrandsRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSupportedBrandsRequest {
            return GetSupportedBrandsRequest.deserialize(bytes);
        }
    }
    export class GetSupportedBrandsResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            brands?: Brand[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("brands" in data && data.brands != undefined) {
                    this.brands = data.brands;
                }
            }
        }
        get brands() {
            return pb_1.Message.getFieldWithDefault(this, 1, []) as Brand[];
        }
        set brands(value: Brand[]) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            brands?: Brand[];
        }): GetSupportedBrandsResponse {
            const message = new GetSupportedBrandsResponse({});
            if (data.brands != null) {
                message.brands = data.brands;
            }
            return message;
        }
        toObject() {
            const data: {
                brands?: Brand[];
            } = {};
            if (this.brands != null) {
                data.brands = this.brands;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.brands.length)
                writer.writePackedEnum(1, this.brands);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetSupportedBrandsResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetSupportedBrandsResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.brands = reader.readPackedEnum();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetSupportedBrandsResponse {
            return GetSupportedBrandsResponse.deserialize(bytes);
        }
    }
    export class DeleteCardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): DeleteCardResponse {
            const message = new DeleteCardResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteCardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteCardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteCardResponse {
            return DeleteCardResponse.deserialize(bytes);
        }
    }
    export class DeleteCardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): DeleteCardRequest {
            const message = new DeleteCardRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): DeleteCardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new DeleteCardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): DeleteCardRequest {
            return DeleteCardRequest.deserialize(bytes);
        }
    }
    export class GetCardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            id?: string;
        }): GetCardRequest {
            const message = new GetCardRequest({});
            if (data.id != null) {
                message.id = data.id;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCardRequest {
            return GetCardRequest.deserialize(bytes);
        }
    }
    export class GetCardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            response?: CardResponse;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("response" in data && data.response != undefined) {
                    this.response = data.response;
                }
            }
        }
        get response() {
            return pb_1.Message.getWrapperField(this, CardResponse, 1) as CardResponse;
        }
        set response(value: CardResponse) {
            pb_1.Message.setWrapperField(this, 1, value);
        }
        get hasResponse() {
            return pb_1.Message.getField(this, 1) != null;
        }
        static fromObject(data: {
            response?: ReturnType<typeof CardResponse.prototype.toObject>;
        }): GetCardResponse {
            const message = new GetCardResponse({});
            if (data.response != null) {
                message.response = CardResponse.fromObject(data.response);
            }
            return message;
        }
        toObject() {
            const data: {
                response?: ReturnType<typeof CardResponse.prototype.toObject>;
            } = {};
            if (this.response != null) {
                data.response = this.response.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.hasResponse)
                writer.writeMessage(1, this.response, () => this.response.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetCardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetCardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.response, () => message.response = CardResponse.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetCardResponse {
            return GetCardResponse.deserialize(bytes);
        }
    }
    export class CardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            encryptedCard?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("encryptedCard" in data && data.encryptedCard != undefined) {
                    this.encryptedCard = data.encryptedCard;
                }
            }
        }
        get encryptedCard() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set encryptedCard(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            encryptedCard?: string;
        }): CardRequest {
            const message = new CardRequest({});
            if (data.encryptedCard != null) {
                message.encryptedCard = data.encryptedCard;
            }
            return message;
        }
        toObject() {
            const data: {
                encryptedCard?: string;
            } = {};
            if (this.encryptedCard != null) {
                data.encryptedCard = this.encryptedCard;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.encryptedCard.length)
                writer.writeString(1, this.encryptedCard);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.encryptedCard = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CardRequest {
            return CardRequest.deserialize(bytes);
        }
    }
    export class TokenizeCardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            expireIn?: number;
            response?: CardResponse;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("expireIn" in data && data.expireIn != undefined) {
                    this.expireIn = data.expireIn;
                }
                if ("response" in data && data.response != undefined) {
                    this.response = data.response;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get expireIn() {
            return pb_1.Message.getFieldWithDefault(this, 2, 0) as number;
        }
        set expireIn(value: number) {
            pb_1.Message.setField(this, 2, value);
        }
        get response() {
            return pb_1.Message.getWrapperField(this, CardResponse, 3) as CardResponse;
        }
        set response(value: CardResponse) {
            pb_1.Message.setWrapperField(this, 3, value);
        }
        get hasResponse() {
            return pb_1.Message.getField(this, 3) != null;
        }
        static fromObject(data: {
            id?: string;
            expireIn?: number;
            response?: ReturnType<typeof CardResponse.prototype.toObject>;
        }): TokenizeCardResponse {
            const message = new TokenizeCardResponse({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.expireIn != null) {
                message.expireIn = data.expireIn;
            }
            if (data.response != null) {
                message.response = CardResponse.fromObject(data.response);
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                expireIn?: number;
                response?: ReturnType<typeof CardResponse.prototype.toObject>;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.expireIn != null) {
                data.expireIn = this.expireIn;
            }
            if (this.response != null) {
                data.response = this.response.toObject();
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.expireIn != 0)
                writer.writeInt32(2, this.expireIn);
            if (this.hasResponse)
                writer.writeMessage(3, this.response, () => this.response.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TokenizeCardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TokenizeCardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.expireIn = reader.readInt32();
                        break;
                    case 3:
                        reader.readMessage(message.response, () => message.response = CardResponse.deserialize(reader));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): TokenizeCardResponse {
            return TokenizeCardResponse.deserialize(bytes);
        }
    }
    export class TokenizeCardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            encryptedBase64?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("encryptedBase64" in data && data.encryptedBase64 != undefined) {
                    this.encryptedBase64 = data.encryptedBase64;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get encryptedBase64() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set encryptedBase64(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            userId?: string;
            encryptedBase64?: string;
        }): TokenizeCardRequest {
            const message = new TokenizeCardRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.encryptedBase64 != null) {
                message.encryptedBase64 = data.encryptedBase64;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                encryptedBase64?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.encryptedBase64 != null) {
                data.encryptedBase64 = this.encryptedBase64;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.encryptedBase64.length)
                writer.writeString(2, this.encryptedBase64);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): TokenizeCardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new TokenizeCardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.encryptedBase64 = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): TokenizeCardRequest {
            return TokenizeCardRequest.deserialize(bytes);
        }
    }
    export class CardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            numberMasked?: string;
            id?: string;
            holderName?: string;
            expirationMonth?: string;
            expirationYear?: string;
            token?: string;
            kind?: Kind;
            brand?: Brand;
            tokenStatus?: TokenStatus;
            tokenId?: string;
            tokenExpirationDate?: string;
            tokenFailureReason?: string;
            numberMaskedBin?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("numberMasked" in data && data.numberMasked != undefined) {
                    this.numberMasked = data.numberMasked;
                }
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("holderName" in data && data.holderName != undefined) {
                    this.holderName = data.holderName;
                }
                if ("expirationMonth" in data && data.expirationMonth != undefined) {
                    this.expirationMonth = data.expirationMonth;
                }
                if ("expirationYear" in data && data.expirationYear != undefined) {
                    this.expirationYear = data.expirationYear;
                }
                if ("token" in data && data.token != undefined) {
                    this.token = data.token;
                }
                if ("kind" in data && data.kind != undefined) {
                    this.kind = data.kind;
                }
                if ("brand" in data && data.brand != undefined) {
                    this.brand = data.brand;
                }
                if ("tokenStatus" in data && data.tokenStatus != undefined) {
                    this.tokenStatus = data.tokenStatus;
                }
                if ("tokenId" in data && data.tokenId != undefined) {
                    this.tokenId = data.tokenId;
                }
                if ("tokenExpirationDate" in data && data.tokenExpirationDate != undefined) {
                    this.tokenExpirationDate = data.tokenExpirationDate;
                }
                if ("tokenFailureReason" in data && data.tokenFailureReason != undefined) {
                    this.tokenFailureReason = data.tokenFailureReason;
                }
                if ("numberMaskedBin" in data && data.numberMaskedBin != undefined) {
                    this.numberMaskedBin = data.numberMaskedBin;
                }
            }
        }
        get numberMasked() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set numberMasked(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get holderName() {
            return pb_1.Message.getFieldWithDefault(this, 3, "") as string;
        }
        set holderName(value: string) {
            pb_1.Message.setField(this, 3, value);
        }
        get expirationMonth() {
            return pb_1.Message.getFieldWithDefault(this, 4, "") as string;
        }
        set expirationMonth(value: string) {
            pb_1.Message.setField(this, 4, value);
        }
        get expirationYear() {
            return pb_1.Message.getFieldWithDefault(this, 5, "") as string;
        }
        set expirationYear(value: string) {
            pb_1.Message.setField(this, 5, value);
        }
        get token() {
            return pb_1.Message.getFieldWithDefault(this, 6, "") as string;
        }
        set token(value: string) {
            pb_1.Message.setField(this, 6, value);
        }
        get kind() {
            return pb_1.Message.getFieldWithDefault(this, 7, Kind.KIND_UNSPECIFIED) as Kind;
        }
        set kind(value: Kind) {
            pb_1.Message.setField(this, 7, value);
        }
        get brand() {
            return pb_1.Message.getFieldWithDefault(this, 8, Brand.BRAND_UNSPECIFIED) as Brand;
        }
        set brand(value: Brand) {
            pb_1.Message.setField(this, 8, value);
        }
        get tokenStatus() {
            return pb_1.Message.getFieldWithDefault(this, 9, TokenStatus.TOKEN_STATUS_UNSPECIFIED) as TokenStatus;
        }
        set tokenStatus(value: TokenStatus) {
            pb_1.Message.setField(this, 9, value);
        }
        get tokenId() {
            return pb_1.Message.getFieldWithDefault(this, 10, "") as string;
        }
        set tokenId(value: string) {
            pb_1.Message.setField(this, 10, value);
        }
        get tokenExpirationDate() {
            return pb_1.Message.getFieldWithDefault(this, 11, "") as string;
        }
        set tokenExpirationDate(value: string) {
            pb_1.Message.setField(this, 11, value);
        }
        get tokenFailureReason() {
            return pb_1.Message.getFieldWithDefault(this, 12, "") as string;
        }
        set tokenFailureReason(value: string) {
            pb_1.Message.setField(this, 12, value);
        }
        get numberMaskedBin() {
            return pb_1.Message.getFieldWithDefault(this, 13, "") as string;
        }
        set numberMaskedBin(value: string) {
            pb_1.Message.setField(this, 13, value);
        }
        static fromObject(data: {
            numberMasked?: string;
            id?: string;
            holderName?: string;
            expirationMonth?: string;
            expirationYear?: string;
            token?: string;
            kind?: Kind;
            brand?: Brand;
            tokenStatus?: TokenStatus;
            tokenId?: string;
            tokenExpirationDate?: string;
            tokenFailureReason?: string;
            numberMaskedBin?: string;
        }): CardResponse {
            const message = new CardResponse({});
            if (data.numberMasked != null) {
                message.numberMasked = data.numberMasked;
            }
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.holderName != null) {
                message.holderName = data.holderName;
            }
            if (data.expirationMonth != null) {
                message.expirationMonth = data.expirationMonth;
            }
            if (data.expirationYear != null) {
                message.expirationYear = data.expirationYear;
            }
            if (data.token != null) {
                message.token = data.token;
            }
            if (data.kind != null) {
                message.kind = data.kind;
            }
            if (data.brand != null) {
                message.brand = data.brand;
            }
            if (data.tokenStatus != null) {
                message.tokenStatus = data.tokenStatus;
            }
            if (data.tokenId != null) {
                message.tokenId = data.tokenId;
            }
            if (data.tokenExpirationDate != null) {
                message.tokenExpirationDate = data.tokenExpirationDate;
            }
            if (data.tokenFailureReason != null) {
                message.tokenFailureReason = data.tokenFailureReason;
            }
            if (data.numberMaskedBin != null) {
                message.numberMaskedBin = data.numberMaskedBin;
            }
            return message;
        }
        toObject() {
            const data: {
                numberMasked?: string;
                id?: string;
                holderName?: string;
                expirationMonth?: string;
                expirationYear?: string;
                token?: string;
                kind?: Kind;
                brand?: Brand;
                tokenStatus?: TokenStatus;
                tokenId?: string;
                tokenExpirationDate?: string;
                tokenFailureReason?: string;
                numberMaskedBin?: string;
            } = {};
            if (this.numberMasked != null) {
                data.numberMasked = this.numberMasked;
            }
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.holderName != null) {
                data.holderName = this.holderName;
            }
            if (this.expirationMonth != null) {
                data.expirationMonth = this.expirationMonth;
            }
            if (this.expirationYear != null) {
                data.expirationYear = this.expirationYear;
            }
            if (this.token != null) {
                data.token = this.token;
            }
            if (this.kind != null) {
                data.kind = this.kind;
            }
            if (this.brand != null) {
                data.brand = this.brand;
            }
            if (this.tokenStatus != null) {
                data.tokenStatus = this.tokenStatus;
            }
            if (this.tokenId != null) {
                data.tokenId = this.tokenId;
            }
            if (this.tokenExpirationDate != null) {
                data.tokenExpirationDate = this.tokenExpirationDate;
            }
            if (this.tokenFailureReason != null) {
                data.tokenFailureReason = this.tokenFailureReason;
            }
            if (this.numberMaskedBin != null) {
                data.numberMaskedBin = this.numberMaskedBin;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.numberMasked.length)
                writer.writeString(1, this.numberMasked);
            if (this.id.length)
                writer.writeString(2, this.id);
            if (this.holderName.length)
                writer.writeString(3, this.holderName);
            if (this.expirationMonth.length)
                writer.writeString(4, this.expirationMonth);
            if (this.expirationYear.length)
                writer.writeString(5, this.expirationYear);
            if (this.token.length)
                writer.writeString(6, this.token);
            if (this.kind != Kind.KIND_UNSPECIFIED)
                writer.writeEnum(7, this.kind);
            if (this.brand != Brand.BRAND_UNSPECIFIED)
                writer.writeEnum(8, this.brand);
            if (this.tokenStatus != TokenStatus.TOKEN_STATUS_UNSPECIFIED)
                writer.writeEnum(9, this.tokenStatus);
            if (this.tokenId.length)
                writer.writeString(10, this.tokenId);
            if (this.tokenExpirationDate.length)
                writer.writeString(11, this.tokenExpirationDate);
            if (this.tokenFailureReason.length)
                writer.writeString(12, this.tokenFailureReason);
            if (this.numberMaskedBin.length)
                writer.writeString(13, this.numberMaskedBin);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.numberMasked = reader.readString();
                        break;
                    case 2:
                        message.id = reader.readString();
                        break;
                    case 3:
                        message.holderName = reader.readString();
                        break;
                    case 4:
                        message.expirationMonth = reader.readString();
                        break;
                    case 5:
                        message.expirationYear = reader.readString();
                        break;
                    case 6:
                        message.token = reader.readString();
                        break;
                    case 7:
                        message.kind = reader.readEnum();
                        break;
                    case 8:
                        message.brand = reader.readEnum();
                        break;
                    case 9:
                        message.tokenStatus = reader.readEnum();
                        break;
                    case 10:
                        message.tokenId = reader.readString();
                        break;
                    case 11:
                        message.tokenExpirationDate = reader.readString();
                        break;
                    case 12:
                        message.tokenFailureReason = reader.readString();
                        break;
                    case 13:
                        message.numberMaskedBin = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CardResponse {
            return CardResponse.deserialize(bytes);
        }
    }
    export class CardToken extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            id?: string;
            token?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("id" in data && data.id != undefined) {
                    this.id = data.id;
                }
                if ("token" in data && data.token != undefined) {
                    this.token = data.token;
                }
            }
        }
        get id() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set id(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get token() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set token(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            id?: string;
            token?: string;
        }): CardToken {
            const message = new CardToken({});
            if (data.id != null) {
                message.id = data.id;
            }
            if (data.token != null) {
                message.token = data.token;
            }
            return message;
        }
        toObject() {
            const data: {
                id?: string;
                token?: string;
            } = {};
            if (this.id != null) {
                data.id = this.id;
            }
            if (this.token != null) {
                data.token = this.token;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.id.length)
                writer.writeString(1, this.id);
            if (this.token.length)
                writer.writeString(2, this.token);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): CardToken {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new CardToken();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.id = reader.readString();
                        break;
                    case 2:
                        message.token = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): CardToken {
            return CardToken.deserialize(bytes);
        }
    }
    export class GetWalletRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            userId?: string;
        }): GetWalletRequest {
            const message = new GetWalletRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetWalletRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetWalletRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetWalletRequest {
            return GetWalletRequest.deserialize(bytes);
        }
    }
    export class GetWalletResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            cards?: CardResponse[];
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("cards" in data && data.cards != undefined) {
                    this.cards = data.cards;
                }
            }
        }
        get cards() {
            return pb_1.Message.getRepeatedWrapperField(this, CardResponse, 1) as CardResponse[];
        }
        set cards(value: CardResponse[]) {
            pb_1.Message.setRepeatedWrapperField(this, 1, value);
        }
        static fromObject(data: {
            cards?: ReturnType<typeof CardResponse.prototype.toObject>[];
        }): GetWalletResponse {
            const message = new GetWalletResponse({});
            if (data.cards != null) {
                message.cards = data.cards.map(item => CardResponse.fromObject(item));
            }
            return message;
        }
        toObject() {
            const data: {
                cards?: ReturnType<typeof CardResponse.prototype.toObject>[];
            } = {};
            if (this.cards != null) {
                data.cards = this.cards.map((item: CardResponse) => item.toObject());
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.cards.length)
                writer.writeRepeatedMessage(1, this.cards, (item: CardResponse) => item.serialize(writer));
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GetWalletResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GetWalletResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        reader.readMessage(message.cards, () => pb_1.Message.addToRepeatedWrapperField(message, 1, CardResponse.deserialize(reader), CardResponse));
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GetWalletResponse {
            return GetWalletResponse.deserialize(bytes);
        }
    }
    export class GeneratePublicCertificateRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        static fromObject(data: {
            userId?: string;
        }): GeneratePublicCertificateRequest {
            const message = new GeneratePublicCertificateRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GeneratePublicCertificateRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GeneratePublicCertificateRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GeneratePublicCertificateRequest {
            return GeneratePublicCertificateRequest.deserialize(bytes);
        }
    }
    export class GeneratePublicCertificateResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            publicKey?: string;
            certificateId?: string;
            expiresAt?: number;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("publicKey" in data && data.publicKey != undefined) {
                    this.publicKey = data.publicKey;
                }
                if ("certificateId" in data && data.certificateId != undefined) {
                    this.certificateId = data.certificateId;
                }
                if ("expiresAt" in data && data.expiresAt != undefined) {
                    this.expiresAt = data.expiresAt;
                }
            }
        }
        get publicKey() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set publicKey(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get certificateId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set certificateId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        get expiresAt() {
            return pb_1.Message.getFieldWithDefault(this, 3, 0) as number;
        }
        set expiresAt(value: number) {
            pb_1.Message.setField(this, 3, value);
        }
        static fromObject(data: {
            publicKey?: string;
            certificateId?: string;
            expiresAt?: number;
        }): GeneratePublicCertificateResponse {
            const message = new GeneratePublicCertificateResponse({});
            if (data.publicKey != null) {
                message.publicKey = data.publicKey;
            }
            if (data.certificateId != null) {
                message.certificateId = data.certificateId;
            }
            if (data.expiresAt != null) {
                message.expiresAt = data.expiresAt;
            }
            return message;
        }
        toObject() {
            const data: {
                publicKey?: string;
                certificateId?: string;
                expiresAt?: number;
            } = {};
            if (this.publicKey != null) {
                data.publicKey = this.publicKey;
            }
            if (this.certificateId != null) {
                data.certificateId = this.certificateId;
            }
            if (this.expiresAt != null) {
                data.expiresAt = this.expiresAt;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.publicKey.length)
                writer.writeString(1, this.publicKey);
            if (this.certificateId.length)
                writer.writeString(2, this.certificateId);
            if (this.expiresAt != 0)
                writer.writeInt64(3, this.expiresAt);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): GeneratePublicCertificateResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new GeneratePublicCertificateResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.publicKey = reader.readString();
                        break;
                    case 2:
                        message.certificateId = reader.readString();
                        break;
                    case 3:
                        message.expiresAt = reader.readInt64();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): GeneratePublicCertificateResponse {
            return GeneratePublicCertificateResponse.deserialize(bytes);
        }
    }
    export class SetDefaultCardRequest extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {
            userId?: string;
            cardTokenId?: string;
        }) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") {
                if ("userId" in data && data.userId != undefined) {
                    this.userId = data.userId;
                }
                if ("cardTokenId" in data && data.cardTokenId != undefined) {
                    this.cardTokenId = data.cardTokenId;
                }
            }
        }
        get userId() {
            return pb_1.Message.getFieldWithDefault(this, 1, "") as string;
        }
        set userId(value: string) {
            pb_1.Message.setField(this, 1, value);
        }
        get cardTokenId() {
            return pb_1.Message.getFieldWithDefault(this, 2, "") as string;
        }
        set cardTokenId(value: string) {
            pb_1.Message.setField(this, 2, value);
        }
        static fromObject(data: {
            userId?: string;
            cardTokenId?: string;
        }): SetDefaultCardRequest {
            const message = new SetDefaultCardRequest({});
            if (data.userId != null) {
                message.userId = data.userId;
            }
            if (data.cardTokenId != null) {
                message.cardTokenId = data.cardTokenId;
            }
            return message;
        }
        toObject() {
            const data: {
                userId?: string;
                cardTokenId?: string;
            } = {};
            if (this.userId != null) {
                data.userId = this.userId;
            }
            if (this.cardTokenId != null) {
                data.cardTokenId = this.cardTokenId;
            }
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (this.userId.length)
                writer.writeString(1, this.userId);
            if (this.cardTokenId.length)
                writer.writeString(2, this.cardTokenId);
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SetDefaultCardRequest {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SetDefaultCardRequest();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    case 1:
                        message.userId = reader.readString();
                        break;
                    case 2:
                        message.cardTokenId = reader.readString();
                        break;
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SetDefaultCardRequest {
            return SetDefaultCardRequest.deserialize(bytes);
        }
    }
    export class SetDefaultCardResponse extends pb_1.Message {
        #one_of_decls: number[][] = [];
        constructor(data?: any[] | {}) {
            super();
            pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls);
            if (!Array.isArray(data) && typeof data == "object") { }
        }
        static fromObject(data: {}): SetDefaultCardResponse {
            const message = new SetDefaultCardResponse({});
            return message;
        }
        toObject() {
            const data: {} = {};
            return data;
        }
        serialize(): Uint8Array;
        serialize(w: pb_1.BinaryWriter): void;
        serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
            const writer = w || new pb_1.BinaryWriter();
            if (!w)
                return writer.getResultBuffer();
        }
        static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SetDefaultCardResponse {
            const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes), message = new SetDefaultCardResponse();
            while (reader.nextField()) {
                if (reader.isEndGroup())
                    break;
                switch (reader.getFieldNumber()) {
                    default: reader.skipField();
                }
            }
            return message;
        }
        serializeBinary(): Uint8Array {
            return this.serialize();
        }
        static override deserializeBinary(bytes: Uint8Array): SetDefaultCardResponse {
            return SetDefaultCardResponse.deserialize(bytes);
        }
    }
    export abstract class UnimplementedCardTokenizerServiceService {
        static definition = {
            TokenizeCard: {
                path: "/tokenizer.v1.CardTokenizerService/TokenizeCard",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: TokenizeCardRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => TokenizeCardRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: TokenizeCardResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => TokenizeCardResponse.deserialize(new Uint8Array(bytes))
            },
            GetCard: {
                path: "/tokenizer.v1.CardTokenizerService/GetCard",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetCardRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetCardRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetCardResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetCardResponse.deserialize(new Uint8Array(bytes))
            },
            GetWallet: {
                path: "/tokenizer.v1.CardTokenizerService/GetWallet",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetWalletRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetWalletRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetWalletResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetWalletResponse.deserialize(new Uint8Array(bytes))
            },
            DeleteCard: {
                path: "/tokenizer.v1.CardTokenizerService/DeleteCard",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: DeleteCardRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => DeleteCardRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: DeleteCardResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => DeleteCardResponse.deserialize(new Uint8Array(bytes))
            },
            GeneratePublicCertificate: {
                path: "/tokenizer.v1.CardTokenizerService/GeneratePublicCertificate",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GeneratePublicCertificateRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GeneratePublicCertificateRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GeneratePublicCertificateResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GeneratePublicCertificateResponse.deserialize(new Uint8Array(bytes))
            },
            SetDefaultCard: {
                path: "/tokenizer.v1.CardTokenizerService/SetDefaultCard",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: SetDefaultCardRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => SetDefaultCardRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: SetDefaultCardResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => SetDefaultCardResponse.deserialize(new Uint8Array(bytes))
            },
            GetInstallments: {
                path: "/tokenizer.v1.CardTokenizerService/GetInstallments",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetInstallmentsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetInstallmentsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetInstallmentsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetInstallmentsResponse.deserialize(new Uint8Array(bytes))
            },
            GetSupportedBrands: {
                path: "/tokenizer.v1.CardTokenizerService/GetSupportedBrands",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: GetSupportedBrandsRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => GetSupportedBrandsRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: GetSupportedBrandsResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => GetSupportedBrandsResponse.deserialize(new Uint8Array(bytes))
            },
            WebhookRedeCardTokens: {
                path: "/tokenizer.v1.CardTokenizerService/WebhookRedeCardTokens",
                requestStream: false,
                responseStream: false,
                requestSerialize: (message: WebhookRedeCardTokensRequest) => Buffer.from(message.serialize()),
                requestDeserialize: (bytes: Buffer) => WebhookRedeCardTokensRequest.deserialize(new Uint8Array(bytes)),
                responseSerialize: (message: WebhookRedeCardTokensResponse) => Buffer.from(message.serialize()),
                responseDeserialize: (bytes: Buffer) => WebhookRedeCardTokensResponse.deserialize(new Uint8Array(bytes))
            }
        };
        [method: string]: grpc_1.UntypedHandleCall;
        abstract TokenizeCard(call: grpc_1.ServerUnaryCall<TokenizeCardRequest, TokenizeCardResponse>, callback: grpc_1.sendUnaryData<TokenizeCardResponse>): void;
        abstract GetCard(call: grpc_1.ServerUnaryCall<GetCardRequest, GetCardResponse>, callback: grpc_1.sendUnaryData<GetCardResponse>): void;
        abstract GetWallet(call: grpc_1.ServerUnaryCall<GetWalletRequest, GetWalletResponse>, callback: grpc_1.sendUnaryData<GetWalletResponse>): void;
        abstract DeleteCard(call: grpc_1.ServerUnaryCall<DeleteCardRequest, DeleteCardResponse>, callback: grpc_1.sendUnaryData<DeleteCardResponse>): void;
        abstract GeneratePublicCertificate(call: grpc_1.ServerUnaryCall<GeneratePublicCertificateRequest, GeneratePublicCertificateResponse>, callback: grpc_1.sendUnaryData<GeneratePublicCertificateResponse>): void;
        abstract SetDefaultCard(call: grpc_1.ServerUnaryCall<SetDefaultCardRequest, SetDefaultCardResponse>, callback: grpc_1.sendUnaryData<SetDefaultCardResponse>): void;
        abstract GetInstallments(call: grpc_1.ServerUnaryCall<GetInstallmentsRequest, GetInstallmentsResponse>, callback: grpc_1.sendUnaryData<GetInstallmentsResponse>): void;
        abstract GetSupportedBrands(call: grpc_1.ServerUnaryCall<GetSupportedBrandsRequest, GetSupportedBrandsResponse>, callback: grpc_1.sendUnaryData<GetSupportedBrandsResponse>): void;
        abstract WebhookRedeCardTokens(call: grpc_1.ServerUnaryCall<WebhookRedeCardTokensRequest, WebhookRedeCardTokensResponse>, callback: grpc_1.sendUnaryData<WebhookRedeCardTokensResponse>): void;
    }
    export class CardTokenizerServiceClient {
        private _address: string;
        private _client: grpc_web_1.GrpcWebClientBase;
        constructor(address: string, credentials?: Object, options?: grpc_web_1.GrpcWebClientBaseOptions) {
            if (!options)
                options = {};
            options.format = options.format || "text";
            this._address = address;
            this._client = new grpc_web_1.GrpcWebClientBase(options);
        }
        private static TokenizeCard = new grpc_web_1.MethodDescriptor<TokenizeCardRequest, TokenizeCardResponse>("/tokenizer.v1.CardTokenizerService/TokenizeCard", grpc_web_1.MethodType.UNARY, TokenizeCardRequest, TokenizeCardResponse, (message: TokenizeCardRequest) => message.serialize(), TokenizeCardResponse.deserialize);
        TokenizeCard(message: TokenizeCardRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<TokenizeCardRequest, TokenizeCardResponse>(this._address + "/tokenizer.v1.CardTokenizerService/TokenizeCard", message, metadata || {}, CardTokenizerServiceClient.TokenizeCard);
        }
        private static GetCard = new grpc_web_1.MethodDescriptor<GetCardRequest, GetCardResponse>("/tokenizer.v1.CardTokenizerService/GetCard", grpc_web_1.MethodType.UNARY, GetCardRequest, GetCardResponse, (message: GetCardRequest) => message.serialize(), GetCardResponse.deserialize);
        GetCard(message: GetCardRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetCardRequest, GetCardResponse>(this._address + "/tokenizer.v1.CardTokenizerService/GetCard", message, metadata || {}, CardTokenizerServiceClient.GetCard);
        }
        private static GetWallet = new grpc_web_1.MethodDescriptor<GetWalletRequest, GetWalletResponse>("/tokenizer.v1.CardTokenizerService/GetWallet", grpc_web_1.MethodType.UNARY, GetWalletRequest, GetWalletResponse, (message: GetWalletRequest) => message.serialize(), GetWalletResponse.deserialize);
        GetWallet(message: GetWalletRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetWalletRequest, GetWalletResponse>(this._address + "/tokenizer.v1.CardTokenizerService/GetWallet", message, metadata || {}, CardTokenizerServiceClient.GetWallet);
        }
        private static DeleteCard = new grpc_web_1.MethodDescriptor<DeleteCardRequest, DeleteCardResponse>("/tokenizer.v1.CardTokenizerService/DeleteCard", grpc_web_1.MethodType.UNARY, DeleteCardRequest, DeleteCardResponse, (message: DeleteCardRequest) => message.serialize(), DeleteCardResponse.deserialize);
        DeleteCard(message: DeleteCardRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<DeleteCardRequest, DeleteCardResponse>(this._address + "/tokenizer.v1.CardTokenizerService/DeleteCard", message, metadata || {}, CardTokenizerServiceClient.DeleteCard);
        }
        private static GeneratePublicCertificate = new grpc_web_1.MethodDescriptor<GeneratePublicCertificateRequest, GeneratePublicCertificateResponse>("/tokenizer.v1.CardTokenizerService/GeneratePublicCertificate", grpc_web_1.MethodType.UNARY, GeneratePublicCertificateRequest, GeneratePublicCertificateResponse, (message: GeneratePublicCertificateRequest) => message.serialize(), GeneratePublicCertificateResponse.deserialize);
        GeneratePublicCertificate(message: GeneratePublicCertificateRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GeneratePublicCertificateRequest, GeneratePublicCertificateResponse>(this._address + "/tokenizer.v1.CardTokenizerService/GeneratePublicCertificate", message, metadata || {}, CardTokenizerServiceClient.GeneratePublicCertificate);
        }
        private static SetDefaultCard = new grpc_web_1.MethodDescriptor<SetDefaultCardRequest, SetDefaultCardResponse>("/tokenizer.v1.CardTokenizerService/SetDefaultCard", grpc_web_1.MethodType.UNARY, SetDefaultCardRequest, SetDefaultCardResponse, (message: SetDefaultCardRequest) => message.serialize(), SetDefaultCardResponse.deserialize);
        SetDefaultCard(message: SetDefaultCardRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<SetDefaultCardRequest, SetDefaultCardResponse>(this._address + "/tokenizer.v1.CardTokenizerService/SetDefaultCard", message, metadata || {}, CardTokenizerServiceClient.SetDefaultCard);
        }
        private static GetInstallments = new grpc_web_1.MethodDescriptor<GetInstallmentsRequest, GetInstallmentsResponse>("/tokenizer.v1.CardTokenizerService/GetInstallments", grpc_web_1.MethodType.UNARY, GetInstallmentsRequest, GetInstallmentsResponse, (message: GetInstallmentsRequest) => message.serialize(), GetInstallmentsResponse.deserialize);
        GetInstallments(message: GetInstallmentsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetInstallmentsRequest, GetInstallmentsResponse>(this._address + "/tokenizer.v1.CardTokenizerService/GetInstallments", message, metadata || {}, CardTokenizerServiceClient.GetInstallments);
        }
        private static GetSupportedBrands = new grpc_web_1.MethodDescriptor<GetSupportedBrandsRequest, GetSupportedBrandsResponse>("/tokenizer.v1.CardTokenizerService/GetSupportedBrands", grpc_web_1.MethodType.UNARY, GetSupportedBrandsRequest, GetSupportedBrandsResponse, (message: GetSupportedBrandsRequest) => message.serialize(), GetSupportedBrandsResponse.deserialize);
        GetSupportedBrands(message: GetSupportedBrandsRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<GetSupportedBrandsRequest, GetSupportedBrandsResponse>(this._address + "/tokenizer.v1.CardTokenizerService/GetSupportedBrands", message, metadata || {}, CardTokenizerServiceClient.GetSupportedBrands);
        }
        private static WebhookRedeCardTokens = new grpc_web_1.MethodDescriptor<WebhookRedeCardTokensRequest, WebhookRedeCardTokensResponse>("/tokenizer.v1.CardTokenizerService/WebhookRedeCardTokens", grpc_web_1.MethodType.UNARY, WebhookRedeCardTokensRequest, WebhookRedeCardTokensResponse, (message: WebhookRedeCardTokensRequest) => message.serialize(), WebhookRedeCardTokensResponse.deserialize);
        WebhookRedeCardTokens(message: WebhookRedeCardTokensRequest, metadata: grpc_web_1.Metadata | null) {
            return this._client.thenableCall<WebhookRedeCardTokensRequest, WebhookRedeCardTokensResponse>(this._address + "/tokenizer.v1.CardTokenizerService/WebhookRedeCardTokens", message, metadata || {}, CardTokenizerServiceClient.WebhookRedeCardTokens);
        }
    }
}
